import  styles from "./Background.module.scss";

export const Background = () => {
  return <div className={styles['background']}/>
}
